import { IconProps } from './types';

export function AddCharacter({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 26 26" {...props}>
      <path
        d="M20.4999 9.55012V10.5501C20.4898 12.5684 19.8691 14.5365 18.7196 16.1955C17.5701 17.8545 15.9454 19.1268 14.0592 19.8452C12.1731 20.5635 10.1137 20.6943 8.15175 20.2204C6.18984 19.7464 4.41727 18.6899 3.06707 17.1897C1.71686 15.6894 0.852231 13.8157 0.586836 11.8149C0.32144 9.8141 0.667705 7.7798 1.58011 5.97946C2.49251 4.17911 3.92835 2.697 5.69885 1.72796C7.46935 0.758917 9.49165 0.348312 11.4999 0.550121M6.49988 12.5503C6.49988 12.5503 7.99988 14.5503 10.4999 14.5503C12.9999 14.5503 14.4999 12.5503 14.4999 12.5503M7.49988 7.55029H7.50988M13.4999 7.55029H13.5099M14.4999 3.55029H20.4999M17.4999 0.550293V6.55029"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
